import { LoadingButton } from '@mui/lab';
import { Card, Container, Stack, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';   // optional - nicer styling

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
}));

const CouponUpdateComponent = () => {
    const navigate = useNavigate();
  const { showToast } = useToaster();
  const [couponCode, setCouponCode] = useState('');
  const [loading, setLoading] = useState(false);
  
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (event) => {
    setCouponCode(event.target.value);
  };

  const handleUpdateCoupon = () => {
    setLoading(true);
    const body = { appsumo_token: couponCode };
    const postProps = {
      url: userModuleURL.couponUpdate, 
      body,
      successCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
  };

  const successCallback = (data, message) => {
    showToast(message || 'Coupon updated successfully!');
    setLoading(false);
    window.location.href = window.location.origin + '/billing';
  };

 const failureCallback = (message) => {
    message && showToast(message, 'e');
    if (
      message &&
      (message.toLowerCase().includes('redeem code not found') ||
       message.toLowerCase().includes('not found') ||
       message.toLowerCase().includes('invalid code') ||
       message.toLowerCase().includes('coupon not found'))
    ) {
      setErrorMessage(
        "The code you entered was not found.\n\n" +
        "Please double-check the code (it's case-sensitive).\n" +
        "Example format: Brand2Social-Business-xxxx-xxxx-xxxx-xxxx"
      );
      setErrorDialogOpen(true);
    }
    setLoading(false);
  };
  const handleCloseErrorDialog = () => {
    setErrorDialogOpen(false);
  }
  return (
    <>
      <Helmet>
        <title>Coupon Update</title>
      </Helmet>
      <StyledRoot style={{ minHeight: '100vh', alignItems: 'center', justifyContent: 'center' }}>
        <Container maxWidth="sm" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
          <Card sx={{ p: 5, boxShadow: 6, borderRadius: 3, width: '100%', maxWidth: 620, mx: 'auto', background: '#fff' }}>
            <StyledContent style={{ minHeight: 'unset', boxShadow: 'none', background: 'transparent', padding: 0 }}>
              <Typography variant="h4" sx={{ mb: 1, textAlign: 'center', fontWeight: 700 }} gutterBottom>
                Coupon Update
              </Typography>
              <Typography variant="body2" sx={{ mb: 3, textAlign: 'center', color: 'text.secondary' }}>
                Enter your coupon code below to update your account benefits.
              </Typography>
              <Stack spacing={3} sx={{ mb: 4 }}>
                <TextField
                  name="couponCode"
                  label="Coupon Code"
                  placeholder='Brand2Social-Business-xxxx-xxxx-xxxx-xxxx'
                  onChange={handleInputChange}
                  value={couponCode}
                  variant="outlined"
                  fullWidth
                  autoFocus
                  InputProps={{ style: { fontSize: 18, letterSpacing: 1 } }}
                />
              </Stack>
              <LoadingButton
                fullWidth
                size="large"
                type="submit"
                loading={loading}
                onClick={handleUpdateCoupon}
                variant="contained"
                sx={{ fontWeight: 600, fontSize: 16, py: 1.5, borderRadius: 2 }}
              >
                Update
              </LoadingButton>
            </StyledContent>
          </Card>
        </Container>
      </StyledRoot>
        <Dialog
              open={errorDialogOpen}
              onClose={handleCloseErrorDialog}
              aria-labelledby="error-dialog-title"
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle id="error-dialog-title" sx={{ color: 'error.main', display: 'flex', alignItems: 'center', gap: 1 }}>
                {/* <ErrorOutlineIcon /> */} {/* optional icon */}
                Code Not Found
              </DialogTitle>
      
              <DialogContent>
                <DialogContentText sx={{ whiteSpace: 'pre-line' }}>
                  {errorMessage}
                </DialogContentText>
      
                {/* Optional: nicer looking error box inside dialog */}
                <Alert severity="error" sx={{ mt: 2 }}>
                  Please check your code and try again.
                </Alert>
              </DialogContent>
      
              <DialogActions>
                <Button onClick={handleCloseErrorDialog} color="primary" variant="contained">
                  OK
                </Button>
              </DialogActions>
            </Dialog>
    </>
  );
};
export default CouponUpdateComponent;
